import React, { FC } from 'react';
import { CurrentCycleContent } from '../../../common/model/dto/current-cycle-content';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvListTable from '../atoms/OvListTable';
import OvListTableRow from '../atoms/OvListTableRow';
import OvListTableHeaderField from '../atoms/OvListTableHeaderField';
import OvCurrentCycleContentListRow from './OvCurrentCycleContentListRow';

interface OvCurrentCycleContentListProps {
  currentCycleContents: CurrentCycleContent[];
}

const OvCurrentCycleContentList: FC<OvCurrentCycleContentListProps> = ({
  currentCycleContents,
}) => {
  const { t } = useTranslation();

  const headerNames = [
    {
      name: 'currentCycleContents.headers.cyclePhase',
    },
    {
      name: 'currentCycleContents.headers.healthGoal',
    },
    {
      name: 'currentCycleContents.headers.age',
    },
    { name: 'common.createdAt' },
    { name: 'common.updatedAt' },
    { name: 'common.action' },
  ];
  return (
    <WrapperBox>
      <OvListTable>
        <OvListTableRow>
          {headerNames.map(({ name }) => (
            <OvListTableHeaderField style={{ cursor: 'pointer' }}>
              {t(name)}
            </OvListTableHeaderField>
          ))}
        </OvListTableRow>

        {currentCycleContents.map((currentCycleContent) => (
          <OvListTableRow key={currentCycleContent.id}>
            <OvCurrentCycleContentListRow
              currentCycleContent={currentCycleContent}
            />
          </OvListTableRow>
        ))}
      </OvListTable>
    </WrapperBox>
  );
};

export default OvCurrentCycleContentList;

const WrapperBox = styled.div`
  padding: 1.5rem 1rem 1rem;
  overflow-x: auto;
`;
